import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from '../assets/img/nav-gmail.svg';
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          {/*<MailchimpForm />*/}
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/devvitto/"><img src={navIcon1} alt="LinkedIn" /></a>
              <a target="_blank" rel="noreferrer" href="mailto:vitto.jsx@gmail.com?subject=Contacto%20desde%20tu%20portfolio&body=Hola%20Vitto,"><img src={navIcon2} alt="Gmail" /></a>
              <a target="_blank" rel="noreferrer" href="https://www.instagram.com/devitto.jsx/"><img src={navIcon3} alt="Instagram" /></a>
            </div>
            <p>Copyright 2025. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
